<template>
	<div>
		<div class="modal_flex" style="justify-content: space-between;">
			<div style="width: 200px; text-align: right">跟进人：<span>{{client.follow_name}}</span></div>
			<div style="width: 200px; text-align: right">客户：<span>{{client.name}}</span></div>
			<div style="width: 200px">性别：<span>{{client.sex_name}}</span></div>
		</div>
		<div class="modal_flex" style="justify-content: space-between;">
			<div style="width: 200px; text-align: right" v-if="userInfo.media_is_open == true">
				媒体代码：<span>{{client.source}}</span></div>
			<div style="width: 200px; text-align: right">需求金额：<span>{{client.loans_money}}</span></div>
			<div style="width: 200px">星级：<span>{{client.start_name}}</span></div>
		</div>
		<div class="modal_flex">
			<div style="width: 130px; text-align: right"><span class="icon iconfont icon-bixuan"></span>进件状态：</div>
			<RadioGroup v-model="formItem.status" :disabled="formItem.check_status ==2 && userInfo.role_type != 4">
				<Radio :label="1" :disabled="formItem.check_status ==2"><span>审核中</span></Radio>
				<Radio :label="2" :disabled="formItem.check_status ==2"><span>已批款</span></Radio>
				<Radio :label="3" :disabled="formItem.check_status ==2"><span>银行已拒绝</span></Radio>
				<Radio :label="4" :disabled="formItem.check_status ==2"><span>已收款</span></Radio>
				<Radio :label="5" :disabled="formItem.check_status ==2"><span>违约</span></Radio>
			</RadioGroup>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>进件产品：</div>
				<Input v-model="formItem.product_id" placeholder="例：招商银行-闪电贷" style="width: 250px;"></Input>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>进件额度：</div>
				<Input v-model="formItem.loans_money" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>邀约客户经理：</div>
				<Select v-model="formItem.add_uid" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width:250px">
					<Option v-for="item in userList" :value="item.value" :key="item.value">
						{{item.label}}
					</Option>
				</Select>
			</div>
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>后勤进件经理：</div>
				<Select v-model="formItem.principal_uid"
					:disabled="formItem.check_status ==2 && userInfo.role_type != 4" style="width:250px">
					<Option v-for="item in userList" :value="item.value" :key="item.value">
						{{item.label}}
					</Option>
				</Select>
			</div>
		</div>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>资方对接人：</div>
				<Input v-model="formItem.manager" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width: 250px;"></Input>
			</div>
		</div>

		<div class="modal_flex">
			<div class="item_box" v-if="formItem.status == 4 || formItem.status == 2">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>批款额度&nbsp;&nbsp;</div>
				<Input v-model="formItem.get_money" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>回款时间&nbsp;&nbsp;</div>
				<DatePicker :value="formItem.repay_at" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					@on-change="(e) => {formItem.repay_at = e}" type="date" placeholder="请选择时间" style="width: 250px">
				</DatePicker>
			</div>
		</div>
		<div class="modal_flex" v-if="formItem.status == 4">
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>诚意金&nbsp;&nbsp;</div>
				<Input v-model="formItem.sincerity_money"
					@on-change="changeChannelMoney(formItem.sincerity_money,formItem.channel_fee,formItem.paymentAmount,formItem.external_fee)"
					:disabled="formItem.check_status ==2 && userInfo.role_type != 4" style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>后勤费用&nbsp;&nbsp;</div>
				<Input v-model="formItem.channel_fee"
					@on-change="changeChannelMoney(formItem.sincerity_money,formItem.channel_fee,formItem.paymentAmount,formItem.external_fee)"
					:disabled="formItem.check_status ==2 && userInfo.role_type != 4" style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
		</div>
		<div class="modal_flex" v-if="formItem.status == 4">
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>收款额度&nbsp;&nbsp;</div>
				<Input v-model="formItem.paymentAmount"
					@on-change="changeChannelMoney(formItem.sincerity_money,formItem.channel_fee,formItem.paymentAmount,formItem.external_fee)"
					:disabled="formItem.check_status ==2 && userInfo.role_type != 4" style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>渠道费用&nbsp;&nbsp;</div>
				<Input v-model="formItem.external_fee"
					@on-change="changeChannelMoney(formItem.sincerity_money,formItem.channel_fee,formItem.paymentAmount,formItem.external_fee)"
					:disabled="formItem.check_status ==2 && userInfo.role_type != 4" style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
		</div>
		<!--div label="费用分配" class="modal_flex">
			<span slot="label" class="check">费用分配</span>
			<div class="sum-allocation">
				<Input disabled class='input-width-sum' placeholder="邀约人"></Input>
				<Select class="input-width-sum" v-model="formItem.add_uid" style="width:158px;"
					 placeholder="请选择分配人">
					<Option value="0">无</Option>
					<Option v-for="item in userList" :value="item.value" :key="item.value">
						{{item.label}}
					</Option>
				</Select>
				<Input v-model="formItem.remark" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width: 500px;" type="textarea" :rows="4"></Input>
			</div>
			<span>剩余可分配业绩：{{ 0 }}元</span>
			<div class="sum-flex" v-for="(item,index) in formItem.achievement_list" :key="index">
				<Select v-model="item.uid" style="width:158px" placeholder="请选择分配人">
					<Option value="0">无</Option>
					<Option v-for="item in userList" :value="item.value" :key="item.value">
						{{item.label}}
					</Option>
				</Select>
				<Input v-model="item.money" class='input-width-sums' 
					placeholder="请输入分配比例"></Input>&nbsp;%
				<span @click="jianClick(index)" class="icon iconfont icon-jian"></span>
			</div>
			<a @click="addClick" class="add-btn"><span class="icon iconfont icon-jia"></span>添加分配人</a>
		</div-->
		<div class="modal_flex" v-if="formItem.status == 4">
			<div class="item_box" v-if="formItem.status == 4">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>净收入</div>
				<Input v-model="formItem.repay_money" disabled style="width: 250px;">
				<div slot="append">元</div></Input>
			</div>
		</div>
		<div class="modal_flex" v-if="formItem.status == 4">
			<span style="padding-left: 15%;">备注：净收入=收款额度+诚意金-后勤费用-渠道费用</span>
		</div>
		<Card v-if="formItem.status == 4">
			<div>
				业绩分成
				<span v-if="(Number(formItem.invate_money) + Number(surplusMoney)) - Number(formItem.repay_money) == 0" style="color: blue;">（业绩分配已ok）</span>
				<span v-else style="color: red;">（业绩分配未完成）</span>
			</div>
			<div class="modal_flex">
				<div class="item_box">
					<div class="title_box"><span class="icon iconfont icon-bixuan"></span>邀约人&nbsp;&nbsp;</div>
					<Select v-model="formItem.add_uid" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
						style="width:250px">
						<Option value="0">无</Option>
						<Option v-for="item in userList" :value="item.value" :key="item.value">
							{{item.label}}
						</Option>
					</Select>
				</div>
				<div class="item_box">
					<div class="title_box"><span class="icon iconfont icon-bixuan"></span>邀约业绩&nbsp;&nbsp;</div>
					<Input v-model="formItem.invate_money" disabled style="width: 250px;">
					<div slot="append">元</div></Input>
				</div>
			</div>

			<div v-for="(item,index) in formItem.achievement_list" class="modal_flex">
				<div class="item_box">
					<div class="title_box"><span class="icon iconfont icon-bixuan"></span>协助谈单人{{index+1}}&nbsp;&nbsp;
					</div>
					<Select v-model="item.uid" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
						style="width:250px">
						<Option value="0">无</Option>
						<Option v-for="item in userList" :value="item.value" :key="item.value">
							{{item.label}}
						</Option>
					</Select>
				</div>
				<div class="item_box">
					<div class="title_box"><span class="icon iconfont icon-bixuan"></span>谈单业绩分成&nbsp;&nbsp;</div>
					<Input v-model="item.money" @on-change="computerSurplusMoney" style="width: 250px;">
					<div slot="append">元</div></Input>
				</div>
				<span @click="jianClick(index)" class="icon iconfont icon-jian"></span>
			</div>
			<span style="cursor: pointer;"><span @click="addClick" class="icon iconfont icon-jia">添加协助人</span></span>
		</Card>
		<div class="modal_flex">
			<div class="item_box">
				<div class="title_box"><span class="icon iconfont icon-bixuan"></span>新增进件备注&nbsp;&nbsp;</div>
				<Input v-model="formItem.remark" :disabled="formItem.check_status ==2 && userInfo.role_type != 4"
					style="width: 500px;" type="textarea" :rows="4"></Input>
			</div>
		</div>
		<!--div class="modal_flex" v-if="formItem.status == 9 || formItem.status == 11 || formItem.status == 13">
		    <div style="width: 130px; text-align: right"><span class="icon iconfont icon-bixuan"></span>诚意金状态：</div>
		    <RadioGroup v-model="formItem.sincrtity_status">
		        <Radio :label="1"><span>暂不处理（转创收）</span></Radio>
		        <Radio :label="2"><span>已退</span></Radio>
		        <Radio :label="3"><span>转创收</span></Radio>
		    </RadioGroup>
		</div-->
	</div>
</template>

<script>
	import MyUpload from '../tool/Upload.vue'
	import {
		getClientRecord
	} from '@/api/client'
	import {
		getLoan,
		saveLoan
	} from '@/api/task'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import {
		getAllOrganization,
		getAllProduct
	} from "../../api/runSet";

	export default {
		name: "EditContract",
		components: {
			MyUpload
		},
		props: ['loanId', 'clientId', 'contractId', 'userList'],
		computed: {
			...mapGetters(['token', 'userInfo']),
		},
		data() {
			return {
				client: [],
				organizationList: [],
				productList: [],
				surplusMoney: 0,
				formItem: {
					join_at: '无',
					manager: '',
					organization_id: 0,
					add_uid: 0,
					product_id: '',
					principal_uid: 0,
					rate: '',
					get_money: '',
					loans_money: '',
					monthly_payment: '',
					periods: '',
					status: 1,
					check_status: '',
					repay_at: '',
					repay_money: '',
					channel_fee: '',
					sincrtity_status: "",
					remark: "",
					assist_uid: 0,
					achievement_list: [{
						uid: 0,
						money: 0
					}],
				}
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			async loadData() {
				let that = this;
				let data = {
					token: that.token
				};
				console.log('jinlailaa')
				let res = await getAllOrganization(that, data);
				if (res.code == 1) {
					that.organizationList = res.data.list;
				}
				if (that.clientId != 0) {
					let data = {
						token: that.token,
						id: that.clientId
					}
					let res = await getClientRecord(that, data);
					if (res.code == 1) {
						that.client = res.data.item;
						
						console.log(that.formItem.add_uid)
					}
				}
				if (that.loanId != 0) {
					let data = {
						token: that.token,
						id: that.loanId
					}
					let res = await getLoan(that, data);
					if (res.code == 1) {
						that.formItem = res.data.item;
						that.formItem.paymentAmount = that.formItem.channel_fee + that.formItem.repay_money
						that.changeOrganization();
					}
					//计算谈单业绩
					var sumProportion = 0;
					this.formItem.achievement_list.forEach(function(val, index) {
						sumProportion += Number(val.money)
					})
					that.surplusMoney = sumProportion
					console.log((Number(that.formItem.invate_money) ))
					console.log(Number(that.surplusMoney))
					console.log((Number(that.formItem.invate_money) + Number(that.surplusMoney)) - Number(that.formItem.repay_money))
				} else {
					that.initForm();
					that.formItem.add_uid = that.client.follow_uid
				}
			},
			jianClick(index) {	
				var that = this
				var sumProportion = 0;
				this.formItem.achievement_list.splice(index, 1)
				this.formItem.achievement_list.forEach(function(val, index) {
					sumProportion += Number(val.money)
				})
				if ((that.formItem.invate_money +sumProportion) > that.formItem.repay_money) {
					that.$Message.warning('总分配业绩不能大于净收入');
					return false;
				} else {
					//计算剩余业绩
					that.formItem.invate_money = (that.formItem.repay_money - sumProportion)
					that.surplusMoney = that.formItem.repay_money - that.formItem.invate_money
				}
			},
			computerSurplusMoney() {
				var that = this
				var sumProportion = 0;
				this.formItem.achievement_list.forEach(function(val, index) {
					sumProportion += Number(val.money)
				})
				if (that.formItem.achievement_list.money > that.formItem.repay_money) {
					that.$Message.warning('总分配业绩不能大于净收入');
					return false;
				} else {
					//计算剩余业绩
					that.formItem.invate_money = (that.formItem.repay_money - sumProportion)
					that.surplusMoney = that.formItem.repay_money - that.formItem.invate_money
				}
				//计算剩余的案源费  

			},
			addClick() {
				let that = this;
				that.formItem.achievement_list.push({
					uid: 0,
					money: 0
				})
			},
			changeSincerityMoney(contract_sincerity_money) {
				//this.formItem.repay_money = this.contract_sincerity_money+
			},
			changeChannelMoney(contract_sincerity_money, channel_fee, paymentAmount, external_fee) {
				if (contract_sincerity_money == undefined || contract_sincerity_money == null) {
					contract_sincerity_money = 0;
				}
				if (paymentAmount == undefined || paymentAmount == null) {
					paymentAmount = 0;
				}
				if (channel_fee == undefined || channel_fee == null) {
					channel_fee = 0;
				}
				if (external_fee == undefined || external_fee == null) {
					external_fee = 0;
				}
				this.formItem.repay_money = Number(contract_sincerity_money) + Number(paymentAmount) - Number(
					channel_fee) - Number(external_fee)
				this.formItem.invate_money = this.formItem.repay_money;
			},
			async changeOrganization() {
				let that = this;
				let data = {
					token: that.token,
					organization_id: that.formItem.organization_id
				};
				let res = await getAllProduct(that, data);
				if (res.code == 1) {
					that.productList = res.data.list;
				}
			},
			initForm() {
				this.formItem = {
					join_at: '无',
					manager: '',
					organization_id: 0,
					add_uid: 0,
					product_id: '',
					principal_uid: 0,
					rate: '',
					get_money: '',
					loans_money: '',
					monthly_payment: '',
					periods: '',
					status: 1,
					repay_at: '',
					repay_money: '',
					channel_fee: '',
					assist_uid: 0,
					achievement_list: [],
				};
			},
			save() {
				var that = this;
				/*
				if(that.formItem.product_id == 0 ||that.formItem.product_id == null){
					this.$Message.error('进件产品不能为空');
					return;				
				}*/
				if (that.formItem.status == 2) {
					if (that.formItem.not_receive_money == "") {
						this.$Message.error('待收金额不能为空');
						return;
					}
				}
				if (that.formItem.status == 4) {
					if (that.formItem.get_money === "") {
						this.$Message.error('批款金额不能为空');
						return;
					}
					if (that.formItem.repay_at === "") {
						this.$Message.error('收款日期不能为空');
						return;
					}
					if (that.formItem.repay_type === "") {
						this.$Message.error('收款方式不能为空');
						return;
					}
					if (that.formItem.channel_fee === "") {
						this.$Message.error('渠道金额不能为空');
						return;
					}
					if (that.formItem.repay_money === "") {
						this.$Message.error('创收金额不能为空');
						return;
					}
					if (that.formItem.invate_money < 0) {
						this.$Message.error('邀约业绩不能小于0');
						return;
					}
					var  sumProportion = 0;
					this.formItem.achievement_list.forEach(function(val, index) {
						sumProportion += Number(val.money)
					})
					if((Number(that.formItem.invate_money) + Number(sumProportion)) - Number(that.formItem.repay_money) !== 0){
						console.log(Number(that.formItem.invate_money) + Number(sumProportion))
						this.$Message.error('邀约业绩+谈单业绩不等于总收款');
						return;						
					}
				}

				if (that.formItem.check_status == 2 && that.userInfo.role_type != 4) {
					that.$emit('reloadData');
					return;
				}
				if (that.formItem.status == 4) {
					that.formItem.check_status = 1;
					var title = "确定保存并提交给财务审核吗？";
				} else {
					var title = "确定保存吗？";
				}
				this.$Modal.confirm({
					title: title,
					onOk: async () => {
						let data = {
							token: that.token,
							data: that.formItem,
							client_id: that.clientId,
							contract_id: that.contractId
						};
						let res = await saveLoan(that, data);
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.initForm();
							that.$emit('reloadData');
						}
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.icon-bixuan {
		color: red;
	}

	.title_css {
		width: 86px;
		text-align: right;
		margin-right: 10px;
	}

	.list_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;
	}

	.modal_flex {
		display: flex;
		align-items: center;
		margin: 10px 0;

		.item_box {
			width: auto;
			display: flex;
			align-items: center;

			.btn {
				margin: 0 10px;
			}

			.title_box {
				width: 130px;
				text-align: right;
			}
		}

		.icon-bixuan {
			color: #FE485B;
		}

		.icon-jian {
			margin-left: 10px;
			color: #2D8CF0;
		}

		.icon-jia {
			cursor: pointer;
			color: #2D8CF0;
		}
	}
</style>
<style scoped lang="less">
	.add-btn {
		display: flex;
		align-items: center;
	}

	.sum-flex {
		display: flex;
		align-items: center;
		margin-bottom: 10px;

		.icon-jian {
			margin-left: 10px;
			color: #2D8CF0;
		}
	}

	.icon-jia {
		color: #2D8CF0;
	}

	.title {
		display: flex;
		margin-bottom: 10px;

		.title-left {
			font-weight: bold;
		}
	}

	.input-width {
		width: 268px;
	}

	.input-width-sum {
		width: 100px;
		margin-right: 10px;
	}

	.input-width-sums {
		width: 158px;
		margin-left: 10px;
	}

	.footer {
		text-align: right;
	}

	.rigth_scroll {
		max-height: 590px;
		width: 450px;
		overflow: auto;
	}

	.rigth_scroll::-webkit-scrollbar {
		/*滚动条整体样式*/
		width: 4px;
		/*高宽分别对应横竖滚动条的尺寸*/
		height: 4px;
	}

	.rigth_scroll::-webkit-scrollbar-thumb {
		/*滚动条里面小方块*/
		border-radius: 5px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: rgba(0, 0, 0, 0.2);
	}

	.rigth_scroll::-webkit-scrollbar-track {
		/*滚动条里面轨道*/
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 0;
		background: rgba(0, 0, 0, 0.1);
	}
</style>